import { AuthPageConfig } from 'types/storefront';

export const defaultAuthPageConfig = (): AuthPageConfig => ({
  showBrandPanel: true,
  showLogo: true,
  useThemeLogo: true,
  showForgotPassword: true,
  showRegister: true,
  showB2bLink: true,
  showBackToStore: true,
  showCopyright: true,
});

const asString = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  return value;
};

const asBool = (value: unknown, fallback: boolean): boolean =>
  typeof value === 'boolean' ? value : fallback;

export const mapAuthPageResponse = (raw: Record<string, unknown> | null | undefined): AuthPageConfig => {
  const data = raw ?? {};
  return {
    showBrandPanel: asBool(data.showBrandPanel, true),
    showLogo: asBool(data.showLogo, true),
    useThemeLogo: asBool(data.useThemeLogo, true),
    logoUrl: asString(data.logoUrl),
    panelTitle: asString(data.panelTitle),
    panelSubtitle: asString(data.panelSubtitle),
    panelBackgroundImageUrl: asString(data.panelBackgroundImageUrl),
    title: asString(data.title),
    subtitle: asString(data.subtitle),
    submitLabel: asString(data.submitLabel),
    loggingInLabel: asString(data.loggingInLabel),
    emailLabel: asString(data.emailLabel),
    passwordLabel: asString(data.passwordLabel),
    forgotPasswordLabel: asString(data.forgotPasswordLabel),
    showForgotPassword: asBool(data.showForgotPassword, true),
    showRegister: asBool(data.showRegister, true),
    noAccountText: asString(data.noAccountText),
    registerButtonLabel: asString(data.registerButtonLabel),
    orText: asString(data.orText),
    showB2bLink: asBool(data.showB2bLink, true),
    b2bLinkLabel: asString(data.b2bLinkLabel),
    showBackToStore: asBool(data.showBackToStore, true),
    backToStoreLabel: asString(data.backToStoreLabel),
    showCopyright: asBool(data.showCopyright, true),
    copyrightText: asString(data.copyrightText),
  };
};

export const interpolateAuthText = (value: string, siteName: string, year = new Date().getFullYear()): string =>
  value
    .replace(/\{\{\s*siteName\s*\}\}/gi, siteName)
    .replace(/\{\{\s*year\s*\}\}/gi, String(year));

export const pickAuthText = (
  configured: string | undefined,
  fallback: string,
  hideIfEmpty = false,
): string => {
  if (configured == null) return fallback;
  const trimmed = configured.trim();
  if (!trimmed) return hideIfEmpty ? '' : fallback;
  return trimmed;
};
